 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AudioCard~AudioStack~app-account":"AudioCard~AudioStack~app-account","app-account":"app-account","Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal":"Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal","Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal":"Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal","app-stacks":"app-stacks","stackCreateModal":"stackCreateModal","stackEditModal":"stackEditModal","app-contact":"app-contact","paywall":"paywall","stackAddModal":"stackAddModal","stackDeleteModal":"stackDeleteModal","app-explore~app-home~app-menu~auth":"app-explore~app-home~app-menu~auth","auth":"auth","app-visionaries":"app-visionaries","app-about":"app-about","app-card":"app-card","app-category":"app-category","app-explore":"app-explore","app-home":"app-home","app-menu":"app-menu","app-helphome":"app-helphome","app-membership":"app-membership","terms":"terms","AudioCard~AudioStack":"AudioCard~AudioStack","AudioCard":"AudioCard","AudioStack":"AudioStack","Card":"Card","PremiumErrorCard":"PremiumErrorCard","Stack":"Stack","new-member-welcome":"new-member-welcome"}[chunkId]||chunkId) + "." + {"AudioCard~AudioStack~app-account":"9f51dd82","app-account":"e8ed1837","Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal":"8ff1737a","Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal":"d96a8098","app-stacks":"ac438747","stackCreateModal":"8dee7026","stackEditModal":"f1247660","app-contact":"ec4f85fb","paywall":"5b65a22a","stackAddModal":"3a072222","stackDeleteModal":"32213e9b","app-explore~app-home~app-menu~auth":"ed0b7cab","auth":"1bb0ee53","app-visionaries":"2f5ab7c8","app-about":"0cd0b2ad","app-card":"bed33209","app-category":"8f77046f","app-explore":"3eeed3dc","app-home":"5130e690","app-menu":"f23d0967","app-helphome":"e5d65f24","app-membership":"043a05e1","chunk-2d0b6747":"879eb939","chunk-76754fc6":"6c0ac4fb","terms":"93d08168","AudioCard~AudioStack":"94b7d398","AudioCard":"4162ef64","AudioStack":"6e1a6b65","Card":"d872afb0","PremiumErrorCard":"30574991","Stack":"0f573648","new-member-welcome":"29b3cb74"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AudioCard~AudioStack~app-account":1,"app-account":1,"Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal":1,"Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal":1,"app-stacks":1,"stackCreateModal":1,"stackEditModal":1,"app-contact":1,"paywall":1,"stackAddModal":1,"app-explore~app-home~app-menu~auth":1,"auth":1,"app-visionaries":1,"app-about":1,"app-card":1,"app-category":1,"app-explore":1,"app-home":1,"app-menu":1,"app-helphome":1,"app-membership":1,"terms":1,"AudioCard~AudioStack":1,"AudioStack":1,"Card":1,"PremiumErrorCard":1,"Stack":1,"new-member-welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AudioCard~AudioStack~app-account":"AudioCard~AudioStack~app-account","app-account":"app-account","Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal":"Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal","Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal":"Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal","app-stacks":"app-stacks","stackCreateModal":"stackCreateModal","stackEditModal":"stackEditModal","app-contact":"app-contact","paywall":"paywall","stackAddModal":"stackAddModal","stackDeleteModal":"stackDeleteModal","app-explore~app-home~app-menu~auth":"app-explore~app-home~app-menu~auth","auth":"auth","app-visionaries":"app-visionaries","app-about":"app-about","app-card":"app-card","app-category":"app-category","app-explore":"app-explore","app-home":"app-home","app-menu":"app-menu","app-helphome":"app-helphome","app-membership":"app-membership","terms":"terms","AudioCard~AudioStack":"AudioCard~AudioStack","AudioCard":"AudioCard","AudioStack":"AudioStack","Card":"Card","PremiumErrorCard":"PremiumErrorCard","Stack":"Stack","new-member-welcome":"new-member-welcome"}[chunkId]||chunkId) + "." + {"AudioCard~AudioStack~app-account":"55412409","app-account":"ad2d43da","Stack~app-contact~app-stacks~paywall~stackAddModal~stackCreateModal~stackDeleteModal~stackEditModal":"b9508b01","Stack~app-stacks~app-visionaries~auth~stackCreateModal~stackEditModal":"e6bdb3a4","app-stacks":"b50bce8b","stackCreateModal":"af1b3ea1","stackEditModal":"2d6e2fb2","app-contact":"d6355d58","paywall":"1f54516c","stackAddModal":"aed4e8d5","stackDeleteModal":"31d6cfe0","app-explore~app-home~app-menu~auth":"bc0a85fd","auth":"a7fc8d7a","app-visionaries":"91b9dfa0","app-about":"2b1be8bd","app-card":"275c709b","app-category":"be77a5c0","app-explore":"6e36c345","app-home":"1228e24b","app-menu":"b5443275","app-helphome":"926a7d08","app-membership":"c9da0c9a","chunk-2d0b6747":"31d6cfe0","chunk-76754fc6":"31d6cfe0","terms":"59e244e0","AudioCard~AudioStack":"a7022ead","AudioCard":"31d6cfe0","AudioStack":"d4d123b9","Card":"ac2201f5","PremiumErrorCard":"1d6def2b","Stack":"853ace22","new-member-welcome":"0e433876"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
